import axios from "axios";
import { baseURL } from ".";

export const returnInfo = async (cookie, orderID) => {
    try {
        const res = await axios.post(`${baseURL}/api/shopee/getReturnInfo`, {
            cookie,
            order_id: orderID,
        });
        return res.data;
    } catch (err) {
        console.error("Lỗi khi confirmOrder:", err);
        throw err;
    }
};

export const requestReturn = async (order_id,
    cookie,
    item_price,
    reason,
    item_id,
    model_id,
    line_item_id) => {
    try {
        const res = await axios.post(`${baseURL}/api/shopee/requestReturn`, {
            order_id,
            cookie,
            item_price,
            reason,
            item_id,
            model_id,
            line_item_id
        });
        return res.data;
    } catch (err) {
        console.error("Lỗi khi confirmOrder:", err);
        throw err;
    }
};

export const cancelOrder = async (order_id,
    cookie,
) => {
    try {
        const res = await axios.post(`${baseURL}/api/shopee/buyerCancelOrder`, {
            order_id,
            cookie,
        });
        return res.data;
    } catch (err) {
        console.error("Lỗi khi confirmOrder:", err);
        throw err;
    }
};